"use client";

import { Box, Container } from "@mui/material";
import { theme } from "@/lib/theme";

interface PageSectionProps {
  children: React.ReactNode;
  backgroundStyle?: "white" | "green" | "purple" | "dots" | "transparent" | "lightLime";
  customGradient?: string;
  id?: string;
}

export const PageSection = ({
  children,
  backgroundStyle = "white",
  customGradient,
  id,
}: PageSectionProps) => {
  const getBackgroundStyles = () => {
    if (customGradient) {
      return {
        background: customGradient,
      };
    }
    switch (backgroundStyle) {
      case "green":
        return {
          backgroundColor: theme.colors.darkLimeGreen,
        };
      case "purple":
        return {
          backgroundColor: theme.colors.lightPurple,
        };
      case "lightLime":
        return {
          backgroundColor: theme.colors.lightLime,
        };
      case "dots":
        return {
          ...theme.patterns.dots,
          backgroundColor: theme.colors.white,
        };
      case "transparent":
        return {
          backgroundColor: "transparent",
        };
      case "white":
      default:
        return {
          backgroundColor: theme.colors.white,
        };
    }
  };

  return (
    <Box
      id={id}
      sx={{
        width: "100vw",
        position: "relative",
        left: "50%",
        right: "50%",
        marginLeft: "-50vw",
        marginRight: "-50vw",
        paddingTop: { xs: 2, sm: 3 },
        ...getBackgroundStyles(),
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: theme.containerWidth.page,
          paddingX: {
            xs: 3, // 24px mobile
            sm: 4, // 32px desktop
          },
          paddingY: {
            xs: 1,
            sm: 2,
          },
        }}
      >
        {children}
      </Container>
    </Box>
  );
};
